import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ModelProvider } from './context/ModelContext';
import { SyncValidationProvider } from './context/SyncValidationContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { VERSION } from './version';
import { initSentry } from './sentry';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Sentry before anything else
// Environment variables are baked into the bundle at build time via process.env
initSentry();

// Make version available globally for service worker
window.APP_VERSION = VERSION;

// Align persisted lastVersion with the bundle that is actually executing (fixes stale 27 after deploy).
try {
  if (localStorage.getItem('lastVersion') !== VERSION) {
    localStorage.setItem('lastVersion', VERSION);
  }
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <ModelProvider>
      <SyncValidationProvider>
        <BrowserRouter future={{ v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </SyncValidationProvider>
    </ModelProvider>
  </ErrorBoundary>
);

// Register the service worker for offline support
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
